import {
  LigneMouvement,
  Sens,
  TYPE_TIERS_DEBITEUR,
  TYPE_TIERS_DEBITEUR_FOURNISSEUR,
  TYPE_TIERS_FOURNISSEUR,
  Tiers,
  TiersInformationsContactList,
  TiersSearchInput,
  type Adresse,
} from '@mairistem/comptabilite';
import React from 'react';
import { isNil, isEmpty } from 'lodash';
import { Icon } from '@mairistem/finances-utils';
import ModeReglementSelect from './ModeReglementSelect';
import BaseProfilEcritureMouvement from '../../../classes/mouvements/profilEcriture/Base/BaseProfilEcritureMouvement';
import getLibelleTiersBySens from '../../../utils/mouvements/tiers';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';

interface TiersInformationsProps {
  adresse: Adresse;
  modeReglement: string;
  onChange: (data: Partial<LigneMouvement>) => void;
  onReset: () => void;
  onTiersChange: (tiers: Tiers) => void;
  placeholderModeReglement?: string;
  placeholderTiersInput?: string;
  profilEcriture: BaseProfilEcritureMouvement;
  sens: string;
  tiers: Tiers;
}

const emptyRib: Partial<LigneMouvement> = {
  cleRib: '',
  iban: '',
  codeBic: '',
  codeBanque: '',
  codeGuichet: '',
  numeroCompte: '',
  libelleBanque: '',
  titulaireCompte: '',
};

const TiersInformations = ({
  adresse,
  modeReglement,
  onChange,
  onReset,
  onTiersChange,
  placeholderModeReglement = '',
  placeholderTiersInput = '',
  profilEcriture,
  sens,
  tiers,
}: TiersInformationsProps) => {
  const libelleTiers = React.useMemo(() => (
    getLibelleTiersBySens(sens)
  ), [sens]);

  const handleOnNewTab = () => {
    window.open(`/tiers/${tiers.identifiant}`, '_blank');
  };

  const handleChangeModeReglements = (e: React.ChangeEvent<HTMLInputElement>, { value }: {
    value: string;
  }) => {
    let data: Partial<LigneMouvement> = { modeReglement: value };
    if (sens === Sens.DEPENSE) {
      if (value !== MODE_REGLEMENT.DEPENSE.VIREMENT && value !== MODE_REGLEMENT.DEPENSE.VIREMENT_GROS_MT) {
        data = {
          ...data,
          ...emptyRib,
        };
      }
    } else if (value !== MODE_REGLEMENT.RECETTE.VIREMENT) {
      data = {
        ...data,
        ...emptyRib,
      };
    }
    onChange(data);
  };

  const handleTiersChange = (newTiers: Tiers) => {
    onTiersChange(newTiers);
  };

  return (
    <>
      <TiersSearchInput
        adresses={['F']}
        contactPrincipal
        debiteurOuFournisseur={[
          sens === Sens.DEPENSE ? TYPE_TIERS_FOURNISSEUR : TYPE_TIERS_DEBITEUR,
          TYPE_TIERS_DEBITEUR_FOURNISSEUR,
        ]}
        label={(
          <>
            {libelleTiers}
            {' '}
            {!isNil(tiers?.identifiant) && (
              <Icon
                link
                name="external alternate"
                onClick={handleOnNewTab}
                title="Ouvrir dans un nouvel onglet"
              />
            )}
          </>
        )}
        onChange={handleTiersChange}
        onReset={onReset}
        placeholder={isEmpty(placeholderTiersInput) ? `Rechercher un tiers ${libelleTiers}` : placeholderTiersInput}
        tiers={tiers}
        withRibs
      />

      <TiersInformationsContactList
        {...(adresse && { adresse })}
        {...(tiers?.contactPrincipal && { contact: tiers.contactPrincipal })}
        {...(tiers?.identifiant && { identifiantTiers: Number(tiers.identifiant) })}
      />

      {
        sens === Sens.DEPENSE && (
          <ModeReglementSelect
            onChange={handleChangeModeReglements}
            placeholder={placeholderModeReglement}
            profilEcriture={profilEcriture}
            sens={sens}
            disabled={isNil(tiers)}
            value={modeReglement}
          />
        )
      }
    </>
  );
};

export default TiersInformations;
